import { useState, useCallback } from 'react';
import api from '../../services/api';
import toastError from '../../errors/toastError';
import { toast } from 'react-toastify';

export const useMessageReactions = () => {
  const [loading, setLoading] = useState(false);

  const addReaction = useCallback(async (messageId, reactionType) => {
    setLoading(true);
    try {
      const response = await api.post(`/messages/${messageId}/reactions`, {
        type: reactionType
      });

      toast.success('Reação adicionada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar reação:', error);
      toastError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const removeReaction = useCallback(async (messageId, reactionType) => {
    // Toggle - usar o mesmo endpoint que adiciona
    return addReaction(messageId, reactionType);
  }, [addReaction]);

  const toggleReaction = useCallback(async (messageId, reactionType) => {
    return addReaction(messageId, reactionType);
  }, [addReaction]);

  return {
    addReaction,
    removeReaction,
    toggleReaction,
    loading
  };
};

export default useMessageReactions;